import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { useCopy } from '@hooks/useCopy';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const CopyLinkMenuItem = ({ url }: { url: string }) => {
  const { copy } = useCopy({ text: url, successMessage: 'Link copied to clipboard' });

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      copy();
    },
    [copy],
  );

  return (
    <DropdownMenuItem onClick={handleClick}>
      <FontAwesomeIcon icon={faCopy} size="lg" />
      <MenuItemLabel>Copy link</MenuItemLabel>
    </DropdownMenuItem>
  );
};
